import React from 'react';
import { ArrowLeft, Calendar, AlertTriangle } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { Avatar } from '../../components/ui/Avatar';
import { Badge } from '../../components/ui/Badge';
import { AttendanceChart } from '../../components/admin/AttendanceChart';
import { ActionSuggestion } from '../../components/admin/ActionSuggestion';
export function StudentDetail() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  return <div className="space-y-6" data-id="element-373">
      <Button variant="ghost" size="sm" leftIcon={<ArrowLeft size={16} data-id="element-375" />} onClick={() => navigate('/admin/dashboard')} data-id="element-374">
        Voltar para Lista
      </Button>

      {/* Header Profile */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-376">
        <div className="flex items-center gap-4" data-id="element-377">
          <Avatar size="xl" alt="Pedro Costa" src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" data-id="element-378" />
          <div data-id="element-379">
            <div className="flex items-center gap-2" data-id="element-380">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-381">Pedro Costa</h1>
              <Badge variant="danger" data-id="element-382">Risco Alto</Badge>
            </div>
            <p className="text-gray-500 flex items-center gap-2 mt-1" data-id="element-383">
              <Calendar size={14} data-id="element-384" />
              Membro desde Fev/2023 • Plano Anual
            </p>
          </div>
        </div>
        <div className="flex gap-2" data-id="element-385">
          <Button variant="outline" data-id="element-386">Ver Histórico</Button>
          <Button data-id="element-387">Entrar em Contato</Button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-388">
        {/* Left Column - Stats & Chart */}
        <div className="lg:col-span-2 space-y-6" data-id="element-389">
          <Card data-id="element-390">
            <h3 className="font-bold text-gray-900 mb-6" data-id="element-391">
              Histórico de Frequência
            </h3>
            <AttendanceChart data-id="element-392" />
            <div className="mt-4 p-4 bg-red-50 rounded-lg border border-red-100 flex items-start gap-3" data-id="element-393">
              <AlertTriangle className="text-red-500 shrink-0 mt-0.5" size={20} data-id="element-394" />
              <div data-id="element-395">
                <p className="font-bold text-red-800 text-sm" data-id="element-396">
                  Queda Brusca Detectada
                </p>
                <p className="text-red-600 text-sm mt-1" data-id="element-397">
                  O aluno passou de uma média de 4x/semana para 0x nas últimas 3
                  semanas.
                </p>
              </div>
            </div>
          </Card>

          <Card data-id="element-398">
            <h3 className="font-bold text-gray-900 mb-4" data-id="element-399">Sugestões de Ação</h3>
            <div className="space-y-4" data-id="element-400">
              <ActionSuggestion type="call" studentName="Pedro" reason="Ausência prolongada (&gt;21 dias)" data-id="element-401" />
              <ActionSuggestion type="invite" studentName="Pedro" reason="Evento de Powerlifting próximo sábado" data-id="element-402" />
            </div>
          </Card>
        </div>

        {/* Right Column - Info */}
        <div className="space-y-6" data-id="element-403">
          <Card data-id="element-404">
            <h3 className="font-bold text-gray-900 mb-4" data-id="element-405">Detalhes do Risco</h3>
            <div className="space-y-4" data-id="element-406">
              <div data-id="element-407">
                <p className="text-xs text-gray-500 uppercase font-bold" data-id="element-408">
                  Probabilidade de Churn
                </p>
                <div className="flex items-center gap-2 mt-1" data-id="element-409">
                  <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-410">
                    <div className="h-full bg-red-500 w-[85%]" data-id="element-411"></div>
                  </div>
                  <span className="font-bold text-red-600" data-id="element-412">85%</span>
                </div>
              </div>

              <div className="pt-4 border-t border-gray-100" data-id="element-413">
                <p className="text-xs text-gray-500 uppercase font-bold mb-2" data-id="element-414">
                  Fatores de Risco
                </p>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-415">
                  <li className="flex items-center gap-2" data-id="element-416">
                    <span className="w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-417"></span>
                    Ausência &gt; 21 dias
                  </li>
                  <li className="flex items-center gap-2" data-id="element-418">
                    <span className="w-1.5 h-1.5 rounded-full bg-orange-500" data-id="element-419"></span>
                    Sem interação no app
                  </li>
                  <li className="flex items-center gap-2" data-id="element-420">
                    <span className="w-1.5 h-1.5 rounded-full bg-yellow-500" data-id="element-421"></span>
                    Fim de contrato em 2 meses
                  </li>
                </ul>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}